import thumbnailImg from 'Static/thumbnails/screenshot--skyscrapers.png';

export default {
  slug: 'skyscrapers',
  title: 'Skyscrapers',
  seriesNumber: '7',
  published: true,
  thumbnailImg,
  subject: 'Physical Sciences',
  graphicFileName: 'Image_Skyscrapers.png',
  graphicAlt:
    'App screenshot of Skyscrapers depicting the inner workings of multiple floors of a skyscraper',
  iconFileName: 'Icon_Skyscrapers.png',
  iconLargeFileName: 'Icon_Skyscrapers@2x.png',
  iconAlt:
    'App icon for Skyscrapers depicting the side view of an entire skyscraper with a gigantic gorilla on top',
  description:
    'Topics covered include engineering, architecture, design, utilities and energy conservation.',
  briefDescription: 'Learn about engineering, design & more.',
  supportedLanguages: [
    'en',
    'af',
    'ar',
    'bg',
    'bn',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'es',
    'fa',
    'fi',
    'fr',
    'he',
    'hi',
    'hr',
    'ht',
    'hu',
    'id',
    'is',
    'it',
    'ja',
    'ko',
    'ms',
    'nb',
    'nl',
    'pa',
    'pl',
    'pt',
    'ro',
    'ru',
    'sr',
    'sv',
    'th',
    'tl',
    'tr',
    'ur',
    'uz',
    'vi',
    'zh-Hans',
    'zh-Hant',
  ],
  scenes: [
    'CloseUp_Electricity',
    'CloseUp_Structure',
    'LayerTransport',
    'FormSlider_Open',
    'LayerWater',
    'FormSlider_Closed',
    'LayerStructure',
    'LayerElectricity',
    'CloseUp_Transport',
    'Skyline',
    'CloseUp_Water',
  ],
  featuredPrintables: ['skyscrapers_notebook'],
  printables: ['concept_map', 'generating_questions'],
  topics: [
    'engineering_challenges',
    'design_solutions',
    'systems',
    'infrastructure',
  ],
  appLinks: {
    appStoreLink:
      'https://apps.apple.com/us/app/skyscrapers-by-tinybop/id1115415865',
    googlePlayLink:
      'https://play.google.com/store/apps/details?id=com.tinybop.Skyscrapers',
    microsoftLink:
      'https://www.microsoft.com/en-us/p/skyscrapers-by-tinybop/9n7vm7k8f00v?activetab=pivot:overviewtab',
  },
};
